import * as React from "react";

function SvgComponent(
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>
) {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.076 13.508l-2.094-2.093c-.747-.747-2.018-.448-2.317.524-.224.672-.972 1.046-1.645.897-1.495-.374-3.514-2.318-3.887-3.888-.225-.673.224-1.42.897-1.645.972-.299 1.27-1.57.523-2.317L6.46 2.892c-.598-.523-1.495-.523-2.019 0l-1.42 1.42c-1.42 1.496.15 5.458 3.663 8.972 3.514 3.514 7.476 5.159 8.971 3.664l1.42-1.421c.524-.598.524-1.495 0-2.018z"
        fill={props.color ?? "#23262F"}
      />
    </svg>
  );
}

export default SvgComponent;
